import { UploadButton } from "@/components";
import { useEffect, useState } from "react";
import UploadInputGroup from "../UploadForm/UploadInputGroup";
import {
    UploadDialog,
    UploadDialogContent,
    UploadDialogHeader,
    UploadDialogBody,
    UploadDialogCloseButton,
} from "./UploadClips.elements";

export const UploadClips = () => {
    const [isOpen, setIsOpen] = useState(false);

    // The "How uploading works" tutorial closes the form when its tour is
    // completed (Done). Nothing is submitted; the draft/files simply go away.
    useEffect(() => {
        const onTourEnded = (e) => {
            if (e?.detail?.outcome === "completed") setIsOpen(false);
        };
        window.addEventListener("clipn:tutorial-upload-tour-ended", onTourEnded);
        return () => window.removeEventListener("clipn:tutorial-upload-tour-ended", onTourEnded);
    }, []);

    return (
        <>
            <UploadButton handleOpenModal={() => setIsOpen(true)} />
            <UploadDialog open={isOpen} onClose={() => setIsOpen(false)}>
                <UploadDialogContent>
                    <UploadDialogHeader>
                        <UploadDialogCloseButton type="button" onClick={() => setIsOpen(false)}>
                            &times;
                        </UploadDialogCloseButton>
                    </UploadDialogHeader>
                    <UploadDialogBody>
                        <UploadInputGroup handleClose={() => setIsOpen(false)} />
                    </UploadDialogBody>
                </UploadDialogContent>
            </UploadDialog>
        </>
    );
};
